import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse, IApiQueryOptions } from 'api/ApiClient';
import { AffiliationType, ApiQueryOperator, EmployeeActionRequiredType, EmployeeStatus, IAction, IApiList, IApiQueryParam, IEmployee } from 'types';
import * as API from '../../../api';
import * as Actions from './actions';
import { Employees } from './types';

interface IEmployeesPayload {
  affiliationId: string;
  affiliationType: AffiliationType;
  options?: IApiQueryOptions;
}

export function* getEmployees({ payload }: IAction<Employees, IEmployeesPayload>) {
  try {
    // Handle special query changes for site dismiss employees
    const query = payload.options?.q ? JSON.parse(JSON.stringify(payload.options?.q)) : undefined;

    if (payload.affiliationType === AffiliationType.SITES) {
      const statusFilter = query?.find((item: IApiQueryParam) => item.key === 'status');

      if (statusFilter && (statusFilter.value.includes(EmployeeStatus.DISMISSED) || statusFilter.value.includes(EmployeeStatus.APPROVED) || statusFilter.value.includes(EmployeeStatus.INVITED))) {
        query.push({
          key: 'sites.status',
          operator: statusFilter.operator,
          value: statusFilter.value,
        });
      }
    }

    if (payload.affiliationType === AffiliationType.ORGANIZATIONS) {
      const statusFilter = query?.find((item: IApiQueryParam) => item.key === 'sites.status');

      if (statusFilter) statusFilter.key = 'status';
    }

    const options = {
      ...payload.options,
      q: query || [],
    };
    const response: ApiResponse<IApiList<IEmployee>> = yield call(API[payload.affiliationType].listEmployees, payload.affiliationId, options);

    yield put(Actions.getEmployeesSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getEmployeesError(error));
  }
}

export function* getActionRequiredEmployeesCount({ payload }: IAction<Employees, IEmployeesPayload>) {
  try {
    const options = {
      limit: 1,
      offset: 0,
      q: [
        {
          key: 'status',
          value: EmployeeStatus.ACTION_REQUIRED,
          operator: ApiQueryOperator.in,
        },
        {
          key: 'action_required',
          value: [EmployeeActionRequiredType.EMPLOYER_APPROVAL, EmployeeActionRequiredType.INVITE_EXPIRED, EmployeeActionRequiredType.INVITE_SEND_FAILURE],
          operator: ApiQueryOperator.in,
        },
      ],
    };
    const response: ApiResponse<IApiList<IEmployee>> = yield call(API[payload.affiliationType].listEmployees, payload.affiliationId, options);

    yield put(Actions.getActionRequiredEmployeesCountSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getActionRequiredEmployeesCountError(error));
  }
}

export function* watchGetEmployees() {
  yield takeEvery(Employees.GET_EMPLOYEES_REQUEST, getEmployees);
}

export function* watchGetActionRequiredEmployeesCount() {
  yield takeEvery(Employees.GET_ACTION_REQUIRED_EMPLOYEES_COUNT_REQUEST, getActionRequiredEmployeesCount);
}

function* employeesSaga() {
  yield all([fork(watchGetEmployees), fork(watchGetActionRequiredEmployeesCount)]);
}
export { employeesSaga };
